import { render, staticRenderFns } from "./plan-affiliations-form.vue?vue&type=template&id=9981bf0e&scoped=true"
import script from "./plan-affiliations-form.vue?vue&type=script&lang=js"
export * from "./plan-affiliations-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9981bf0e",
  null
  
)

export default component.exports